import { render, staticRenderFns } from "./Landing.html?vue&type=template&id=08acea38&"
import script from "./Landing.ts?vue&type=script&lang=ts&"
export * from "./Landing.ts?vue&type=script&lang=ts&"
import style0 from "./Landing.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports